import { createFileRoute } from '@tanstack/react-router'
import { FeatureGate } from '@/components/feature-locked'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/roster'
)({
  component: RosterLayout,
})

function RosterLayout() {
  return <FeatureGate feature='image' />
}
